export default {"src":"/_next/static/media/destinations.b0ced71d.svg","height":36,"width":56,"blurWidth":0,"blurHeight":0};